import React, { useState } from 'react'
import DOMPurify from 'dompurify'
import { BtnV2, color, Icon, l, TextArea } from '@manychat/manyui'

import cm from './MobileBanner.module.css'

interface UserInputProps {
  goBack: () => void
  onSend: (userInput: string) => void
}

export const UserInput = ({ goBack, onSend }: UserInputProps) => {
  const [value, setValue] = useState('')

  const handleButtonClick = () => {
    onSend(DOMPurify.sanitize(value))
  }

  return (
    <div className={cm.surveyContainer}>
      <Icon.ChevronLeft
        size={24}
        color={color.icon.subtle}
        className={cm.backIcon}
        onClick={goBack}
      />
      <h1 id="improve-label">{l.translate('What can we do to improve Manychat App?')}</h1>
      <TextArea
        ariaLabelledBy="improve-label"
        onChange={(event) => setValue(event.target.value)}
        placeholder={l.translate('Please be direct…')}
        className="m-y-lg"
        minRows={6}
        value={value}
      />
      <BtnV2 fullWidth variant="primary" onClick={handleButtonClick} disabled={!value}>
        {l.translate('Send')}
      </BtnV2>
    </div>
  )
}
